import { render, staticRenderFns } from "./ModalUnpublishItem.vue?vue&type=template&id=ee1bd436&scoped=true"
import script from "./ModalUnpublishItem.vue?vue&type=script&lang=js"
export * from "./ModalUnpublishItem.vue?vue&type=script&lang=js"
import style0 from "./ModalUnpublishItem.vue?vue&type=style&index=0&id=ee1bd436&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1bd436",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee1bd436')) {
      api.createRecord('ee1bd436', component.options)
    } else {
      api.reload('ee1bd436', component.options)
    }
    module.hot.accept("./ModalUnpublishItem.vue?vue&type=template&id=ee1bd436&scoped=true", function () {
      api.rerender('ee1bd436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalUnpublishItem.vue"
export default component.exports